import { gsap } from "gsap";

export default class TimelineIntroVersionHandler {
	init() {
		gsap.utils.toArray('[data-timeline="container"]').forEach((container) => {
			const line = container.querySelector('[data-timeline="line"]');
			const paginationItems = container.querySelectorAll('[data-timeline="pagination"]');
			
			if (line && paginationItems.length > 1) {
				// Get the first and last pagination items
				const firstItem = paginationItems[0];
				const lastItem = paginationItems[paginationItems.length - 1];
				
				// Calculate the distance between them
				const firstRect = firstItem.getBoundingClientRect();
				const lastRect = lastItem.getBoundingClientRect();
				const containerRect = container.getBoundingClientRect();
				
				// Calculate height from first to last pagination item
				const totalHeight = (lastRect.top + lastRect.height/2) - (firstRect.top + firstRect.height/2);
				
				// Set the line height to match this distance
				gsap.set(line, {
					height: totalHeight
				});
			}
		});
	}
}